// components/ArticleList.tsx
import React, { useEffect } from 'react';
import { TFunction } from 'next-i18next'
import { SeccionesPerfil, menuActividad, menuCuenta, menuOtros } from '@/objects/Menus';
import { MenuPerfil } from '@/objects/Menus';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import RowMenu from './RowMenu';
import { useServices } from '@/context/ServicesProvider';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { MensajesChatObj } from '@/objects/Chat';

interface Props {
  opcionActual: SeccionesPerfil;
  opcionSeleccionada: (opcion: SeccionesPerfil) => void;
  t: TFunction;
}

const MenuPerfilScreen: React.FC<Props> = ({ opcionActual, opcionSeleccionada, t }) => {

  const { mensajesQueries, articulosQueries, beseifQueries } = useServices();

  const [menuCuentaNotificaciones, setMenuCuentaNotificaciones] = React.useState<MenuPerfil[]>(menuCuenta);
  const [menuActividadNotificaciones, setMenuActividadNotificaciones] = React.useState<MenuPerfil[]>(menuActividad);

  const [iniciadoSesion, setIniciadoSesion] = React.useState<boolean>(false);

  useEffect(() => {
    if (cargarDatosUsuario() == null) {
      setIniciadoSesion(false);
      return;
    } else {
      setIniciadoSesion(true);
    }

    const datosUsuario = cargarDatosUsuario();

    const mensajesPromise = mensajesQueries?.obtenerMensajesNoLeidos(Number(datosUsuario?.id_user));
    const articulosPromise = articulosQueries?.obtenerArticulosSinPuntuar(Number(datosUsuario?.id_user));
    const beseifPromise = beseifQueries?.obtenerAvisosCompraBeseif(Number(datosUsuario?.id_user));

    //Espera a que se cumplan los dos
    Promise.all([mensajesPromise, beseifPromise]).then(([mensajesResponse, beseifResponse]) => {
      const chatSinLeer: MensajesChatObj[] = mensajesResponse!.data;
      const totalMensajesNoLeidos = chatSinLeer.length;
      const notificacionesBeseif: number = beseifResponse!.data;

      const menuCuentaNotificaciones = menuCuenta.map((opcion: MenuPerfil) => {
        if (opcion.clave_seccion == SeccionesPerfil.MENSAJES) {
          return {
            ...opcion,
            notificaciones: totalMensajesNoLeidos
          }
        }
        if (opcion.clave_seccion == SeccionesPerfil.MIS_COMPRAS) {
          return {
            ...opcion,
            notificaciones: notificacionesBeseif
          }
        }
        return opcion;
      });

      setMenuCuentaNotificaciones(menuCuentaNotificaciones);
    }).catch((error: any) => {
      // Manejar el error
    });

    Promise.all([articulosPromise]).then(([articulosResponse]) => {
      const puntuarUsuarioLibro: number = articulosResponse!.data.puntuar.length;

      const menuActividadNotificaciones = menuActividad.map((opcion: MenuPerfil) => {
        if (opcion.clave_seccion == SeccionesPerfil.PUNTUACIONES) {
          return {
            ...opcion,
            notificaciones: puntuarUsuarioLibro
          }
        }
        return opcion;
      });

      setMenuActividadNotificaciones(menuActividadNotificaciones);
    }).catch((error: any) => {
      // Manejar el error
    });

  }, []);

  return (
    //recorre las opciones del menu de menuCuenta
    iniciadoSesion &&
    <section style={{ paddingLeft: "10px", paddingRight: "10px", paddingBottom: "25px" }}>
      <TituloSeccionH2 texto={t("menu:opciones.cuenta")} />
      {menuCuentaNotificaciones.map((opcion: MenuPerfil) => (
        <RowMenu key={opcion.id} numeroNotificaciones={opcion.notificaciones} opcion={opcion} opcionActual={opcionActual} opcionSeleccionada={opcionSeleccionada} t={t} />
      ))
      }
      <TituloSeccionH2 texto={t("menu:opciones.actividad")} />
      {menuActividadNotificaciones.map((opcion: MenuPerfil) => (
        <RowMenu key={opcion.id} numeroNotificaciones={opcion.notificaciones} opcion={opcion} opcionActual={opcionActual} opcionSeleccionada={opcionSeleccionada} t={t} />
      ))
      }
      <TituloSeccionH2 texto={t("menu:opciones.otros")} />
      {menuOtros.map((opcion: MenuPerfil) => (
        <RowMenu key={opcion.id} numeroNotificaciones={opcion.notificaciones} opcion={opcion} opcionActual={opcionActual} opcionSeleccionada={opcionSeleccionada} t={t} />
      ))
      }
    </section>
  );
};

export default MenuPerfilScreen;
